module.exports = __webpack_public_path__ + "img/multiLineTextEle.f70556f9.svg";